module.exports = __webpack_public_path__ + "static/img-para-que-serve-7e7ed95405b321cf19dc1b38024be812.svg";